import { HttpClient, HttpParams, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';;

@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

  apiURL: string = environment.apiBaseUrl + 'relatorio';

  constructor(private http: HttpClient) { }

  contrato(id: number, segmento?: string | null): Observable<HttpResponse<Blob>> {

    const headers = new HttpHeaders({
      'Accept': 'application/pdf'
    });

    let params = new HttpParams();
    if (segmento) {
      params = params.set('segmento', segmento);
    }

    return this.http.get(`${this.apiURL}/licencaUsoSistema/${id}`, {
      headers: headers,
      params,
      responseType: 'blob',
      observe: 'response'
    });
  }

  contasReceber(filtros: { dataInicio?: string; dataFim?: string; tipoFiltro?: string; pagador?: string; segmentoId?: any; situacao?: string; }): Observable<Blob> {
    return this.gerar('contasReceber', filtros);
  }

  contasPagar(filtros: { dataInicio?: string; dataFim?: string; tipoFiltro?: string; favorecido?: string; segmentoId?: any; situacao?: string; }): Observable<Blob> {
    return this.gerar('contasPagar', filtros);
  }

  tickets(filtros: { dataInicio?: string; dataFim?: string; id?: any; segmento?: string; prioridade?: string; tipo?: string; status?: string; assunto?: string; }): Observable<Blob> {
    return this.gerar('tickets', filtros);
  }

  clientes(filtros: { dataInicio?: string; dataFim?: string; tipoFiltro?: string; parametroConsulta?: string; }): Observable<Blob> {
    return this.gerar('clientes', filtros);
  }

  private gerar(endpoint: string, filtros: any): Observable<Blob> {
    return this.http.get(`${this.apiURL}/${endpoint}`, {
      params: this.montarParams(filtros),
      responseType: 'blob'
    });
  }

  private montarParams(filtros: any): HttpParams {
    let params = new HttpParams();
    Object.keys(filtros || {}).forEach(chave => {
      const valor = filtros[chave];
      if (valor !== null && valor !== undefined && valor !== '') {
        params = params.set(chave, valor);
      }
    });
    return params;
  }
}
